import { Box, Button, Icon, List, Spinner, Text } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import { Option } from 'modules/layout/components/ResponsivePage/_PageHeader/_Actions'

export interface FileDropItemProps {
  fileName: string
  status: 'waiting' | 'processing' | 'success' | 'error'
  options?: Option[]
  onRemove?: () => void
}

export const FileDropItem = ({ fileName, status, onRemove, options = [] }: FileDropItemProps) => {
  return (
    <List.Item>
      <List.Title ellipsis>
        <Box flexDirection="row" alignItems="center" justifyContent="flexStart" gap="s12">
          <Box flexNoShrink>
            {status == 'processing' ? (
              <Box paddingX="s4">
                <Spinner size="s24" />
              </Box>
            ) : (
              <Icon.Large
                icon={mapIconFromStatus(status)}
                color={mapColorFromStatus(status)}
              ></Icon.Large>
            )}
          </Box>
          <Box>
            <Text.Normal>{fileName}</Text.Normal>
          </Box>
        </Box>
      </List.Title>
      <List.Description>
        <Box
          height="s32"
          flexDirection="row"
          justifyContent="spaceBetween"
          alignItems="center"
          paddingLeft="s12"
          gap="s12"
          flexNoShrink
        >
          {status == 'success' && (
            <Text.Normal size="200" overflowWrap={false} whiteSpace="nowrap">
              {i18n.t('finance.invoices.upload_invoice_modal.status.uploaded')}
            </Text.Normal>
          )}
          {status == 'error' && (
            <Text.Normal color="radicalRed1000" size="200" whiteSpace="nowrap">
              {i18n.t('finance.invoices.upload_invoice_modal.status.error')}
            </Text.Normal>
          )}
          {status !== 'processing' && onRemove && (
            <Button type="secondary" iconName="delete" onClick={onRemove} />
          )}
          {status !== 'waiting' && status !== 'processing' && options.length > 0 && (
            <Popover type="list">
              <Popover.Trigger>
                <Button.Decorative type="secondary" iconName="ellipsis" />
              </Popover.Trigger>
              <Popover.Content side="bottom" align="center" hideWhenDetached={false}>
                {options.map((item: Option, index: number) => {
                  return (
                    <Popover.TouchableOption
                      key={item.title + '_' + item.description}
                      title={item.title}
                      description={item.description}
                      onClick={item.onClick}
                      danger={item.danger}
                      disabled={item.disabled}
                    />
                  )
                })}
              </Popover.Content>
            </Popover>
          )}
        </Box>
      </List.Description>
    </List.Item>
  )
}

const mapColorFromStatus = (status: FileDropItemProps['status']) => {
  switch (status) {
    case 'error':
      return 'radicalRed1000'
    default:
      return 'grey600'
  }
}

const mapIconFromStatus = (status: FileDropItemProps['status']) => {
  switch (status) {
    case 'waiting':
      return 'file-upload'
    case 'processing':
      return 'file-upload'
    case 'success':
      return 'document-approved'
    case 'error':
      return 'file-error'
  }
}
